import { UserMenu } from '@auth/features/auth';
import { PendingCommentsTrigger } from '@itineraries/features/pending-comments-indicator';
import { NotificationDrawerTrigger } from '@notifications/widgets/notification-drawer';
import { Menu } from 'lucide-react';
import { Button } from '@/shared/ui';
import { useOrgLogoUrl } from '../lib/use-org-logo';
import css from './mobile-header.module.scss';

type MobileHeaderProps = {
  onMenuToggle: () => void;
};

export const MobileHeader = ({ onMenuToggle }: MobileHeaderProps) => {
  const logoUrl = useOrgLogoUrl();
  return (
    <header className={css.root}>
      <Button
        aria-label="Open menu"
        className={css.menuBtn}
        icon={<Menu className={css.menuIcon} />}
        onClick={onMenuToggle}
        size="icon"
        variant="ghost"
      />
      <img alt="Logo" className={css.brand} src={logoUrl} />
      {/*
        The desktop top bar is hidden below 768px, so the bell has to be mounted
        here too or mobile users would never see a notification.
      */}
      <div className={css.actions}>
        <PendingCommentsTrigger className={css.headerControl} />
        <NotificationDrawerTrigger className={css.headerControl} />
        <UserMenu />
      </div>
    </header>
  );
};
